import { UpperCasePipe } from '@angular/common';
import { Component, OnInit, signal } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { RegisteredSerialsService } from '../../services/registered-serials.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { RegisteredSerial } from '../../models/registered-serial';
import { UserDataService } from '../../services/user-data.service';
import dayjs from 'dayjs';
import { FormatDatePipe } from '../../pipes/format-date.pipe';
import { Utils } from '../../services/utils.service';

@Component({
  selector: 'app-serial-check',
  imports: [TranslatePipe, FormsModule, ReactiveFormsModule, UpperCasePipe, FormatDatePipe],
  templateUrl: './serial-check.component.html',
  styleUrls: ['./serial-check.component.scss']
})
export class SerialCheckComponent implements OnInit {

  form!: FormGroup;
  notFound = signal<boolean>(false);
  registeredSerial = signal<RegisteredSerial | undefined>(undefined);
  purchaseDate = signal<string>('');
  termDate = signal<string>('');
  expired = signal<boolean>(false);

  constructor(
    private fb: FormBuilder,
    private registeredSerialsService: RegisteredSerialsService,
    private spinner: NgxSpinnerService,
    private userDataService: UserDataService,
    private translate: TranslateService,
    private utils: Utils,
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      serial: ['', [Validators.required]],
    });
  }

  search() {
    if (!this.form.valid) {
      return;
    }
    const serial = this.form.get('serial')?.value;
    this.spinner.show();
    this.registeredSerialsService.checkRegisteredSerial(serial).subscribe({
      next: data => {
        this.refreshTrainerName(data);
        this.spinner.hide();
        this.notFound.set(false);
        this.registeredSerial.set(data);
        this.refreshDates();
      },
      error: error => {
        this.spinner.hide();
        if (error.status == 404) {
          this.notFound.set(true);
          this.registeredSerial.set(undefined);
        } else {
          this.utils.showMessage(error, this.translate.instant('network_request_error'));
        }
      }
    });
  }

  private refreshTrainerName(data: RegisteredSerial) {
    const trainers = this.userDataService.trainers();
    const index = trainers.findIndex(t => {
      return t.code === data.trainerCode;
    });
    if (index != -1) {
      data.trainerName = trainers[index].name;
    } else {
      data.trainerName = '-';
    }
  }

  private refreshDates() {
    const data = this.registeredSerial();
    if (data && data.purchaseDate) {
      let purchaseDate = dayjs(data.purchaseDate);
      let termDate = purchaseDate.add(data.warrantyYears, 'year');
      this.purchaseDate.set(purchaseDate.toISOString());
      this.termDate.set(termDate.toISOString());
      this.expired.set(termDate.diff(dayjs()) < 0);
    } else {
      this.purchaseDate.set('');
      this.termDate.set('');
      this.expired.set(false);
    }
  }

  getTrainerImageURL(code: number): string {
    return `https://s3.eu-west-1.amazonaws.com/com.elite.repository/assets/trainers/${code}_t.jpg`
  }
}
